import { OverlayBase } from "./OverlayBase.js";
import { MasterIndex } from "../AMasterIndex.js";
import { NDVIAPI } from "../../APICommands/NDVIAPI.js";

export class NDVIOverlay extends OverlayBase {
    static imageBacklogDate = new Date(Date.now());
    static _workingPromise = undefined;
    static async addToImagesBacklog(startTime: Date): Promise<void> {
        if (startTime.valueOf() > this.imageBacklogDate.valueOf()) {
            return;
        }
        let resolveSelf = undefined;
        const ownPromise = new Promise((resolve) => {
            resolveSelf = resolve;
        });
        const oldWorkingPromise = this._workingPromise;
        this._workingPromise = ownPromise;
        try {
            await oldWorkingPromise;
            if (startTime.valueOf() > this.imageBacklogDate.valueOf()) {
                resolveSelf();
                return;
            }
            const images = await NDVIAPI.getMany({
                startTime: startTime,
                endTime: this.imageBacklogDate,
            });
            if (Array.isArray(images)) {
                images.forEach((imageJson) => new NDVIOverlay(imageJson));
            }
            this.imageBacklogDate = new Date(startTime.valueOf());
        } catch (e) {
            console.warn(e);
        }
        resolveSelf();
    }

    // loads data into global store on creation
    constructor(json) {
        super(json);
        this.type = "NDVI";
        if (json.aoi) {
            MasterIndex.aoi
                .byIDeventually(json.aoi)
                .then((r) => {
                    this.linkedAreaOfInterest = r;
                })
                .catch(() => {
                    console.warn(`Could not find aoi ${json.aoi} in master index`);
                });
        }
        NDVIOverlay.imageBacklogDate = new Date(Math.min(this.date.valueOf(), NDVIOverlay.imageBacklogDate.valueOf()));
        this.load().catch((e) => {
            console.warn(e);
        });
    }
}
